var map = {
	"./1.svg": 1328,
	"./10.svg": 6518,
	"./11.svg": 3472,
	"./2.svg": 2270,
	"./3.svg": 2389,
	"./4.svg": 5356,
	"./5.svg": 6299,
	"./6.svg": 6600,
	"./7.svg": 3014,
	"./8.svg": 7094,
	"./9.svg": 1245,
	"./analysis.svg": 1490,
	"./biaoxingshuju.svg": 1488,
	"./blast.svg": 5026,
	"./blast1.svg": 4117,
	"./browse.svg": 1511,
	"./deseq2.svg": 5019,
	"./download.svg": 8696,
	"./expression.svg": 7542,
	"./go.svg": 9030,
	"./home.svg": 7155,
	"./icon1.svg": 4744,
	"./icon2.svg": 8652,
	"./icon3.svg": 4714,
	"./icon4.svg": 5813,
	"./icon5.svg": 9648,
	"./icon6.svg": 2242,
	"./jiyinxin.svg": 1586,
	"./kegg.svg": 2421,
	"./language.svg": 2874,
	"./msa.svg": 6091,
	"./msaDown.svg": 5197,
	"./pathway.svg": 8908,
	"./peo.svg": 4428,
	"./search.svg": 95,
	"./sequence.svg": 2564,
	"./sequence1.svg": 2314,
	"./te.svg": 9888,
	"./tools.svg": 8734,
	"./venn.svg": 6951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1620;